import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import * as api from '../api/client';

interface KbOption {
  id: string;
  name: string;
}

interface Props {
  userId?: string;
  value?: string;
  onChange?: (kbId: string) => void;
}

const KnowledgeBaseSelector: React.FC<Props> = ({ userId = '', value, onChange }) => {
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const [items, setItems] = useState<KbOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      try {
        const res = query.trim()
          ? await api.searchKnowledgeBaseCatalog(query.trim(), 20)
          : await api.listKnowledgeBases({ user_id: userId, status: 'ACTIVE', limit: 50 });
        if (cancelled) return;
        const rows = res.data?.knowledge_bases || [];
        setItems(rows.map((kb: any) => ({ id: kb.id, name: kb.name })));
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void run();
    return () => { cancelled = true; };
  }, [query, userId]);

  const options = useMemo(
    () => items.map((kb) => ({ value: kb.id, label: kb.name })),
    [items],
  );

  return (
    <Select
      showSearch
      value={value}
      placeholder="Select a knowledge base"
      style={{ width: '100%' }}
      loading={loading}
      options={options}
      filterOption={false}
      onSearch={setQuery}
      onChange={(next) => onChange?.(String(next))}
    />
  );
};

export default KnowledgeBaseSelector;
